import React from "react";
import styles from "./full-screen-modal.module.css";
import { useDispatch, useSelector } from "react-redux";
import { inactive } from "../../../../store/reducers/toggle/fullScreenArcpintToggle";
import { LOCALES, UI_TEXT } from "../../../../constants";
import { getUIText } from "../../../../translation";

export default function FullScreenModal({ lang, savior, imgSrc }) {
    const fullscreenToggle = useSelector((state) => state.fullscreen.value);

    const dispatch = useDispatch();

    const src =
        imgSrc || (savior && `${process.env.PUBLIC_URL}/images/arcpoint/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]}).webp`);

    if (src)
        return (
            <div className={`${styles["modal"]} ${fullscreenToggle ? `${styles["active"]}` : ""}`} onClick={() => dispatch(inactive())}>
                <img src={src} />
                <div className={styles["hint"]}>{getUIText(lang, "savior.modal.arcpoint.close")}</div>
            </div>
        );
}
